import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import styles from "./CustomLoader.module.css";

const sizeMap = {
  sm: 20,
  md: 32,
  lg: 48,
};

const CustomLoader = ({
  size = "md",
  text,
  fullScreen = false,
  overlay = false,
  className = "",
}) => {
  const content = (
    <div className={`${styles.loaderContent} ${className}`}>
      <CircularProgress
        size={sizeMap[size] || sizeMap.md}
        sx={{ color: "var(--color-primary)" }}
      />
      {text && <span className={styles.text}>{text}</span>}
    </div>
  );

  if (fullScreen || overlay) {
    return (
      <div
        className={`${styles.wrapper} ${
          fullScreen ? styles.fullScreen : styles.overlay
        }`}
      >
        {content}
      </div>
    );
  }

  return content;
};

export default CustomLoader;
